<div class="col-md-6 offset-md-3 mt-5">
<div class="navbar-header text-center">
  <a class="" rel="home" href="/envista" >
      <img class="responsive" style="width:50%;height: auto;"
           src="assets/images/Noble.png">
  </a>
</div>
<section id="header" class="rounded" style="margin-top:1%;background-color:white;text-align: center;text-emphasis-color: inherit"><strong></strong>
  <div class="container">
      <div class="row" >
          <div class="col-md-12 col-xs-12 col-centered" style="align-items: center;
          text-decoration: underline;">
          <strong>Error Page</strong></div>
      </div>
  </div>
</section>
<div class="card" style="margin-top: 1%">
<h4 class="card-header">Error Page</h4>
<div class="card-body"  >


      <div class="col-md-6" style="float: left;">

        <div class="form-group paymentMsgDiv">
          <div class="errPageDiv">
            <!-- <div>
              <mat-icon class="errorIcon">sentiment_very_dissatisfied</mat-icon>
            </div> -->
            <div><H1> Opps! </H1> </div>
            <div class="errTextMsgDiv">
              <span style= "color: #495057;"> {{errorData.statusMsg}}</span>
            </div>
            <div class="errBackButtonDiv">
              <button class="errBackButton" mat-raised-button (click)="redirectHome()" color="primary">BACK TO HOME</button>
            </div>

          </div>
        </div>

      </div>

</div>
</div>
</div>
